export default __webpack_public_path__ + "static/media/cow-2.be3f457b.png";